export const settingsHubTr = {
  title: 'Ayarlar',
  subtitle: 'Kiracının tüm yapılandırma alanları tek bir yerde.',
  personal: 'Kişisel',
  configuration: 'Yapılandırma',
  empty: 'Rolünüz için kullanılabilir yapılandırma alanı yok.',
  areas: {
    setup: {
      title: 'Kurulum ve kurulum kontrolü',
      description: 'Rehberli kiracı kurulumu, ilerleme, testler ve onay.',
    },
    profile: {
      title: 'Profilim',
      description: 'Ad, dil ve görüntüleme tercihleri.',
    },
    security: {
      title: 'Güvenlik',
      description: 'Şifre, iki faktörlü kimlik doğrulama ve aktif oturumlar.',
    },
    company: {
      title: 'Şirket profili',
      description: 'Ana veriler, banka bilgileri, KDV numarası ve varsayılan belge metinleri.',
    },
    users: {
      title: 'Kullanıcılar ve roller',
      description: 'Ekip hesapları, RBAC izin matrisi ve zorunlu iki faktör.',
    },
    pdfDesigner: {
      title: 'PDF tasarımcısı',
      description: 'Teklifler, siparişler ve faturalar için şablonları sürükleyip bırakın.',
    },
    documentHeaders: {
      title: 'Belge başlığındaki müşteri verileri',
      description: 'Alanları, bölümleri ve görünürlüğü belge türüne göre yönetin.',
    },
    accounting: {
      title: 'DATEV ve Intrastat',
      description: 'SKR03/04 hesap eşleme, danışman ve müşteri numarası, raporlama çalışmaları.',
    },
    banking: {
      title: 'Bankacılık ve mutabakat',
      description: 'AISP, eşitleme, mutabakat, hesap eşleme ve güvenli içe aktarma profilleri.',
    },
    whatsapp: {
      title: "WhatsApp Business API'si",
      description: 'Meta Cloud API belirteçleri, web kancaları ve mesaj şablonları.',
    },
    notifications: {
      title: 'Bildirimler',
      description: 'Minimum stok kuralları, uyarılardan ve ödemelerden önce en iyisi.',
    },
    salesRules: {
      title: 'Satış kuralları ve müşteri bakımı',
      description: 'Önerileri simüle edin, eşikleri yönetin ve otomatik çalışmaları planlayın.',
    },
    translations: {
      title: 'Diller ve çeviriler',
      description: 'Kiracıya özel terimleri ve korunan adları yönetin.',
    },
    customFields: {
      title: 'Özel alanlar ve GoBD kasası',
      description: 'Dinamik ek alanlar ve kurcalanmaya karşı korumalı değişiklik günlükleri.',
    },
    system: {
      title: 'Sistem ve yedeklemeler',
      description: 'SMTP testi, veritabanı yedeklemeleri, içe/dışa aktarma ve telemetri.',
    },
  },
  links: {
    setup: 'Kurulumu aç',
    company: 'Şirket verilerini düzenle',
    users: 'Kullanıcı yönetimi',
    roles: 'Roller ve izinler',
    securityLog: 'Güvenlik günlüğü',
    templates: 'Belge şablonları',
    documentHeaders: 'Belge başlığındaki müşteri verileri',
    accounting: 'Hesap eşleme',
    datev: 'DATEV dışa aktarımı',
    intrastat: 'Intrastat raporu',
    banking: 'Bankacılığı yapılandır',
    whatsapp: 'Bağlantı ve şablonlar',
    notifications: 'Uyarı kuralları',
    salesRules: 'Satış kurallarını yönet',
    translations: 'Çeviri sözlüğü',
    customFields: 'Özel alanlar',
    auditVault: 'GoBD kasası',
    system: 'Sistem sağlığı',
    errorLogs: 'Hata merkezi',
    mailBackups: 'Posta sunucusu ve yedeklemeler',
    dataHub: 'İçe ve dışa aktarma',
  },
} as const;
